import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@/app/features/auth/services/auth.service';

export const guestMatchGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Si ya está logueado, no  matchear /auth y manda a /home
  return auth.isAuthenticated() ? router.createUrlTree(['/home']) : true;
};